const SHOW_PRESENT_MAP = 'SHOW_PRESENT_MAP';

export {
  SHOW_PRESENT_MAP,
};
